// Module
var code = `<template>
  <require from="./nav-change-widget.scss"></require>

  <div class="nav-change-widget">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <!-- chart slightly sticks out from its boundaries, 97% makes sure there's no scroll -->
    <div show.bind="!loading && !error" class="nav-change-widget__chart" style="height: 97%" element.ref="chart">
    </div>
    <message if.bind="error" icon="error" colour="mdc-theme--error" class="nav-change-widget__error">
      \${error.message}</message>
    <div if.bind="noGL" class="nav-change-widget__no-gl-warning warning">
      Warning: No GL data available for this period
    </div>
  </div>
</template>
`;
// Exports
export default code;